import { useQuery } from "react-query";
import { TRawUser, IRawUser } from "@propely/propely-typings";
import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { AuthenticationTokenData } from "@src/to-be-removed/LocalData/General/AuthenticationTokenData";
import { useUserByIdKey } from "@src/data-hooks/user/user.service";
import { useAuthStatus } from "@src/auth/useAuthStatus";

export const getCurrentUser = () => {
  const auth = getAuth();
  const userId = auth.currentUser?.uid ?? "";
  const { isExternal, isSignedIn, authCheckComplete } = useAuthStatus();

  // Unconditionally define the useQuery hook
  const $user = useQuery(
    useUserByIdKey(userId),
    async () => {
      const result = await getDoc(doc(getFirestore(), "users", userId));
      return TRawUser.parse({ ...result.data(), id: result.id });
    },
    {
      enabled: !isExternal && isSignedIn && !!userId, // Only enable if conditions are met
    }
  );

  // Conditionally return based on isExternal and isSignedOut
  if (isExternal) {
    const user: IRawUser = {
      id: userId,
      properties: AuthenticationTokenData.token?.claims.properties.map((property) => property.data.id) ?? [],
    };
    return {
      userId,
      isExternal,
      $user: {
        data: user,
        isLoading: false,
        isSuccess: true,
        isError: false,
        error: null,
      },
      user: user,
      authCheckComplete,
    };
  } else {
    return {
      userId,
      isExternal,
      $user,
      user: $user.data,
      authCheckComplete,
    };
  }
};
